<div class="edit-user-wrapper">
  @if (isLoading) {
  <app-spinner></app-spinner>
  } @if (!isLoading) {
  <div class="edit-user">
    <div class="page-action">
      @if (!isNew && ps.checkPermissions(permissions.user_reset_password)) {
      <div class="btn btn-primary" (click)="resetPassword()">
        Reset Password
        <span class="icon icon-right">
          <i class="fa fa-lock"></i>
        </span>
      </div>
      } @if (!isNew && isMFAResetAllowed) {
      <div class="btn btn-primary" (click)="resetMFASecret()">
        Reset MFA Secret
        <span class="icon icon-right">
          <i class="fa fa-key"></i>
        </span>
      </div>
      } @if (!isNew && isLoginAttemptsResetAllowed) {
      <div class="btn btn-primary" (click)="resetLoginAttempts()">
        Reset Login Attempts
        <span class="icon icon-right">
          <i class="fa fa-unlock"></i>
        </span>
      </div>
      }
    </div>
    <client-header
      [headerLabel]="'User Information'"
      [headerGroup]="'user-information'"
      (toggleHeader)="showUserInfo = !showUserInfo"
    >
    </client-header>
    @if (showUserInfo) {
    <div class="collapse-container user-info-container">
      <rn-text-input
        [inputLabel]="'Email'"
        [inputControl]="userInfoValidGroup.controls['email']"
        [placeholderText]="'Email'"
        [trimOnBlur]="true"
        [readOnly]="!isNew"
        [newValue]="false"
      >
        <rn-input-info-box
          input-info-box
          [svgHeight]="78"
          [svgPosition]="'8,0 8,33, 2,39 8,45 8,78'"
          [text]="
            'This will be the user\'s primary ID and be used to reset their passwords.  An invitation for them to log into the CX Builder the first time will be sent to this address.'
          "
        ></rn-input-info-box>
      </rn-text-input>
      <rn-text-input
        [inputLabel]="'First Name'"
        [inputControl]="userInfoValidGroup.controls['first_name']"
        [placeholderText]="'First Name'"
      ></rn-text-input>
      <rn-text-input
        [inputLabel]="'Last Name'"
        [inputControl]="userInfoValidGroup.controls['last_name']"
        [placeholderText]="'Last Name'"
      ></rn-text-input>
    </div>
    }
    <br />
    <client-header
      [headerLabel]="'Roles'"
      [headerGroup]="'roles'"
      (toggleHeader)="showRoleInfo = !showRoleInfo"
    >
    </client-header>
    @if (showRoleInfo) {
    <div class="collapse-container user-role-info-container">
      <label for="admin-role-select">Admin Role</label>
      <div class="input-container">
        <select
          name="admin-role-select"
          class="form-control"
          (change)="adminRoleChange()"
          [formControl]="userInfoValidGroup.controls['admin_role']"
          [ngClass]="{
            'has-error':
              !userInfoValidGroup.controls['admin_role'].valid &&
              userInfoValidGroup.controls['admin_role'].touched
          }"
        >
          <option value="" default>Select an Admin Role</option>
          @for (adminRoleOption of adminRoleOptions; track adminRoleOption) {
          <option
            [ngValue]="adminRoleOption.id"
            [selected]="adminRoleOption.id === selectedAdminRole.value"
          >
            {{ adminRoleOption.id | inputField }}
          </option>
          }
        </select>
        <app-error-display
          [control]="userInfoValidGroup.controls['admin_role']"
        ></app-error-display>
      </div>
      @if (twoWayService.showTwoWay()) {
      <label for="two-way-role-select"
        >@if (!currentClient.feed_enabled) {
        <span>Two Way Messaging Role</span>
        }@if (currentClient.feed_enabled) {
        <span>Relay Messenger Role</span>
        }</label
      >
      <div class="input-container">
        <select
          name="two-way-role-select"
          class="form-control"
          (change)="roleChange()"
          [formControl]="userInfoValidGroup.controls['two_way_role']"
          [ngClass]="{
            'has-error':
              !userInfoValidGroup.controls['two_way_role'].valid &&
              userInfoValidGroup.controls['two_way_role'].touched
          }"
        >
          @if (!currentClient.feed_enabled) {
          <option value="" default>Select a Two-Way Messaging Role</option>
          } @if (currentClient.feed_enabled) {
          <option value="" default>Select a Relay Messager Role</option>
          } @for (twoWayRoleOption of twoWayRoleOptions; track twoWayRoleOption)
          {
          <option
            [ngValue]="twoWayRoleOption.id"
            [selected]="twoWayRoleOption.id === selectedTwoWayRole.value"
          >
            @if ( twoWayRoleOption.id === 'two_way_admin' &&
            currentClient.feed_enabled ) {
            <span>Messenger Admin </span>
            } @if ( twoWayRoleOption.id === 'two_way_user' &&
            currentClient.feed_enabled ) {
            <span>Messenger User </span>
            } @if ( twoWayRoleOption.id === 'two_way_admin' &&
            !currentClient.feed_enabled ) {
            <span>Two Way Admin </span>
            } @if ( twoWayRoleOption.id === 'two_way_user' &&
            !currentClient.feed_enabled ) {
            <span>Two Way User </span>
            } @if ( twoWayRoleOption.id !== 'two_way_admin' &&
            twoWayRoleOption.id !== 'two_way_user' ) {
            <span>
              {{ twoWayRoleOption.id | inputField }}
            </span>
            }
          </option>
          }
        </select>
      </div>
      @if (!hideControlGroup) {
      <div>
        <label for="two-way-control-group-select">Control Group</label>
        <div class="input-container">
          <select
            name="two-way-group-select"
            class="form-control"
            (change)="controlGroupChanged($event.target.value)"
            [formControl]="userInfoValidGroup.controls['group_id']"
            [ngClass]="{
              'has-error':
                !userInfoValidGroup.controls['group_id'].valid &&
                userInfoValidGroup.controls['group_id'].touched
            }"
          >
            <option value="" disabled>Select a Control Group</option>
            <option [value]="''" default>No Control Group</option>
            @for (controlGroup of controlGroups; track controlGroup) {
            <option
              [value]="controlGroup.group_id"
              [selected]="controlGroup.group_id === selectedControlGroupId"
            >
              {{ controlGroup.group_name }}
            </option>
            }
          </select>
        </div>
      </div>
      } }
    </div>
    }
    <client-header
      [headerLabel]="'Clients'"
      [headerGroup]="'clients'"
      (toggleHeader)="showClientInfo = !showClientInfo"
    >
    </client-header>
    @if (showClientInfo) {
    <div class="collapse-container user-role-info-container">
      <div class="user-clients">
        <div class="input-container">
          <label>Primary Client</label>
          @if (isNew) {
          <select
            class="form-control"
            [formControl]="userInfoValidGroup.controls['primary_client']"
            [ngClass]="{
              'has-error':
                !userInfoValidGroup.controls['primary_client'].valid &&
                userInfoValidGroup.controls['primary_client'].touched
            }"
          >
            @for (client of availableClients; track client; let i = $index) {
            <option
              class="available-client-option-{{ i }}"
              [ngValue]="client.id"
              [selected]="client.id === user.client_id"
            >
              {{ client.company_name }}
            </option>
            }
          </select>
          <app-error-display
            [control]="userInfoValidGroup.controls['primary_client']"
          ></app-error-display>
          } @else {
          <input
            class="form-control"
            [formControl]="userInfoValidGroup.controls['primary_client']"
          />
          }
        </div>
        @if (selectedSecondaryClients.length > 10 && !showAll) {
        <p (click)="showAll = !showAll" class="btn-link">Show All</p>
        } @if (availableSecondaryClients.length) {
        <div class="add-client-container">
          <label>Secondary Clients</label>
          <div class="input-container">
            <!-- selectedSecondaryClient is a temp variable that isn't part of the Reactive form -->
            <select class="form-control" [(ngModel)]="selectedSecondaryClient">
              <option value="">Select</option>
              @for (client of availableSecondaryClients; track client; let i =
              $index) {
              <option
                class="available-client-option-{{ i }}"
                [ngValue]="client"
              >
                {{ client.company_name }}
              </option>
              }
            </select>
            <div class="add-client btn btn-primary" (click)="addClient()">
              Add
            </div>
          </div>
        </div>
        }
        <div class="secondary-client-container">
          @for (client of selectedSecondaryClients; track client; let i =
          $index) { @if (i < 10 || showAll) {
          <div class="secondary-client-{{ i }}">
            <div>
              <span class="company-name">{{ getCompanyNameById(client) }}</span
              >@if (canRemove(client)) {
              <span
                class="remove remove-client"
                (click)="removeClient(client, i)"
                ><i class="fa fa-minus-circle"></i
              ></span>
              }
            </div>
          </div>
          } }
        </div>
        @if (selectedSecondaryClients.length > 10 && !showAll) {
        <p (click)="showAll = !showAll" class="show-all btn-link">Show All</p>
        }
      </div>
    </div>
    } @if (!isNew && isQuicksightRegistrationToggleEnabled) {
    <client-header
      [headerLabel]="'Relay Insights Studio'"
      [headerGroup]="'quicksight'"
      (toggleHeader)="showQuicksightInfo = !showQuicksightInfo"
    >
    </client-header>
    @if (showQuicksightInfo) {
    <div class="collapse-container quicksight-info-container">
      <rn-toggle-switch
        [inputName]="'quicksight-reader-toggle'"
        [labelText]="'Register as Relay Insights Studio READER'"
        [toggleModel]="isQuicksightRegistered"
        [disabled]="isQuicksightToggleDisabled"
        [tooltipText]="quicksightToggleTooltip"
        (toggleModelChange)="onQuicksightToggle()"
      ></rn-toggle-switch>
      @if (quicksightProvisioning) {
      <span class="quicksight-status quicksight-status--loading"
        >Provisioning Relay Insights Studio access…</span
      >
      } @else if (quicksightStatusLoading) {
      <span class="quicksight-status quicksight-status--loading"
        >Checking status...</span
      >
      } @else if (quicksightRole === 'READER') {
      <span class="quicksight-status">Registered as READER</span>
      } @else if (quicksightRole === 'AUTHOR') {
      <span class="quicksight-status">Registered as AUTHOR</span>
      } @else {
      <span class="quicksight-status">Not registered</span>
      }
    </div>
    } }
    <br />
    <hr />
    <div class="button-container">
      <button
        id="prev-btn"
        class="btn btn-primary btn-with-icon"
        (click)="handleClose()"
      >
        <span class="icon icon-left">
          <i class="fa fa-arrow-left"></i>
        </span>
        <span class="btn-label">Cancel</span>
      </button>
      <button id="next-btn" class="btn btn-primary" (click)="onSave()">
        <span i18n="Label for save user button" id="finish-button">{{
          isNew ? 'Create' : 'Save'
        }}</span>
        <span class="icon icon-right">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
        </span>
      </button>
    </div>
  </div>
  } @if (showReset) {
  <div class="modal" style="display: block">
    <app-user-reset
      [config]="resetPasswordConfig()"
      (closeWindow)="handleClose($event)"
    ></app-user-reset>
  </div>
  }
  <message-dialog></message-dialog>
  <message-dialog #resetMfaSucess [showAffirm]="false" [showClose]="true">
    <div class="text-left px-3">
      <h3>MFA Secret has been reset.</h3>
      <p>
        The user <strong>{{ user.email_address }}</strong> will need to
        re-authenticate on their next login.
      </p>
    </div>
  </message-dialog>
  <message-dialog #resetMfaFail [showAffirm]="false" [showClose]="true">
    <div class="text-left px-3">
      <h3>Failed to reset MFA Secret.</h3>
    </div>
  </message-dialog>
  <message-dialog
    #resetLoginAttemptsSuccess
    [showAffirm]="false"
    [showClose]="true"
  >
    <div class="text-left px-3">
      <h3>Login attempts have been reset.</h3>
      <p>
        The user <strong>{{ user.email_address }}</strong> is no longer blocked
        and can log in again.
      </p>
    </div>
  </message-dialog>
  <message-dialog
    #resetLoginAttemptsFail
    [showAffirm]="false"
    [showClose]="true"
  >
    <div class="text-left px-3">
      <h3>Failed to reset login attempts.</h3>
    </div>
  </message-dialog>
</div>
